import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const SimpleDialog = ({
    open,
    template,
    title = 'Confirm',
    text = 'Are you sure you would like to continue?',
    cancelText = 'Cancel',
    okText = 'Yes',
    onClose,
    PaperProps
}) => {
    return (
        <Dialog
            open={open}
            onClose={() => onClose && onClose(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            PaperProps={PaperProps}
        >
            <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {text}
                </DialogContentText>
                {template}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => onClose && onClose(false)}
                    variant='contained'
                >
                    {cancelText}
                </Button>
                <Button
                    onClick={() => onClose && onClose(true)}
                    color="primary"
                    variant="contained"
                >
                    {okText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SimpleDialog;
